/**
 * Decides whether an add-to-cart should open the cart drawer.
 *
 * Rule (see docs/superpowers/specs/2026-07-06-quieter-add-to-cart-design.md):
 * open the drawer only when the cart was empty before this add (first item in
 * cart) OR the delivery-date modal was shown for this add. Every other add is
 * confirmed silently (in-button "Added" state + bubble bounce + aria announce).
 *
 * cartEmptiedForAdd counts as cartWasEmpty: the catering-over-regular swap
 * (product-form.js) removes the cart's regular lines just before its add, so the
 * drawer still reads as non-empty when the add starts.
 *
 * Pure and DOM-free so it's require()-able in node:test.
 */
(function (root, factory) {
  var api = factory();
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.CartOpenPolicy = api;
})(typeof self !== 'undefined' ? self : this, function () {
  function shouldOpenCart(signals) {
    var s = signals || {};
    return Boolean(s.cartWasEmpty) || Boolean(s.cartEmptiedForAdd) || Boolean(s.dateModalWasShown);
  }

  return { shouldOpenCart: shouldOpenCart };
});
